import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "6", x: "9", y: "9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "StopCircle";
const StopCircle = memo(themed(Icon));
export {
  StopCircle
};
//# sourceMappingURL=stop-circle.js.map
